/**
 * Vulnerability disclosure policy publication metadata (AIR-1104 §7).
 *
 * VDP_IS_DRAFT plays the DPA_IS_DRAFT role with stricter semantics (the
 * DPA shows its text behind a banner; the VDP hides every commitment):
 * while true, /security renders a pending notice WITHOUT the reporting
 * channel, response SLAs, or safe harbor, /.well-known/security.txt
 * answers 404, the page is noindex, and the LegalFooter link stays hidden
 * — the canonical policy doc
 * (docs/compliance/vanta/evidence/vulnerability-disclosure-policy.md §3/§7)
 * forbids representing the policy externally as in force until
 * security@aireserve.com is a live, monitored Workspace group and counsel
 * (Gal) has signed off on the public copy.
 *
 * THE PUBLICATION (FLIP) PR must: set VDP_IS_DRAFT = false, refresh
 * VDP_LAST_UPDATED to the actual publication date, and re-check
 * VDP_SECURITY_TXT_EXPIRES is comfortably in the future (the page test's
 * 60-day renewal window arms itself only after the flip). Footer, robots,
 * and the smoke expectations reverse automatically off the flag.
 * Registered as SC-30 in CLAIMS.md.
 *
 * PUBLISHED by the 2026-09-09 flip PR — both §7 gates met:
 * security@aireserve.com is live as a monitored Workspace group (routes to
 * the product inbox) and counsel (Gal) signed off on the public copy
 * 2026-09-08.
 *
 * Deliberately a plain module (no "use client", no imports): the page is a
 * Server Component rendering these values as visible legal text, and
 * scripts/smoke-test.ts imports the flag relative-path to pick the right
 * post-deploy expectation.
 */
export const VDP_IS_DRAFT = false;

export const VDP_LAST_UPDATED = "September 9, 2026";

export const VDP_CONTACT_EMAIL = "security@aireserve.com";

/** The published policy URL — security.txt's Policy field and the page canonical. */
export const VDP_POLICY_URL = "https://aireserve.com/security";

/**
 * RFC 9116 requires a maintained Expires under a year out. The page test
 * fails 60 days BEFORE this date (renewal window), not at it.
 */
export const VDP_SECURITY_TXT_EXPIRES = "2027-09-01T00:00:00.000Z";
